import dayjs from "dayjs";
dayjs.locale('es')
export const formatoFechaHora =(fecha) =>{
    if (!fecha) {
        return ''
    }

    let fec = dayjs(fecha).format('hh : mma')
    return fec.substring(0, 1).toUpperCase() + fec.substring(1, fecha.length)
}